import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import lineGreen from '../../images/service/liine-green.svg'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSectionS2 = (props) => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await fetch('/api/blogs');
                const data = await res.json();
                setBlogs(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching blogs:', error);
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };
        fetchBlogs();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
    };

    const settings = {
        infinite: true,
        autoplay: true,
        arrows: false,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [

            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                }
            },
            {
                breakpoint: 757,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                     dots: true
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    };

    return (
        <section className={"" + props.tClass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12">
                        <div className="section-title text-center">
                            <span style={{color: '#0D0A0B'}}>Community News & Updates</span>
                            <h2>Latest <span style={{position: 'relative', color: '#2A896F'}}>Articles
                                <img src={lineGreen} alt="" style={{position: 'absolute', left: 0, bottom: '-10px', width: '100%'}} />
                            </span> & Blogs</h2>
                        </div>
                    </div>
                </div>
                <div className="blog-slider">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>Loading articles...</div>
                    ) : (
                        <Slider {...settings}>
                            {blogs.slice(0, 6).map((blog, bkye) => (
                                <div className="blog-card-s2" key={blog.id || bkye}>
                                    <div className="image">
                                        <img src={blog.image_url || '/images/blog/img-1.jpg'} alt={blog.title} />
                                    </div>
                                    <div className="content">
                                        <ul>
                                            <li><i className="flaticon-calendar"></i>{formatDate(blog.published_at || blog.created_at)}</li>
                                            <li><i className="flaticon-chat"></i>0 Comments</li>
                                        </ul>
                                        <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h3>
                                        <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>Read More <i className="flaticon-right-arrow"></i></Link>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    )}
                </div>
            </div>
        </section>
    );
}

export default BlogSectionS2;




